<app-toast></app-toast>
<app-global-loader></app-global-loader>

<router-outlet></router-outlet>
